import React from 'react';
import MUIDataTable from 'mui-datatables';
import PapperBlock from '../../../../components/PapperBlock/PapperBlock';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import styles from './../reportes-jss'
import { textLabelsEs } from '../../../../utils/tableTexts';
import LoaderFull from '../../../../components/Loader/LoaderFull';
import { LanguageConsumer, LanguageCxt } from './../../../../language/LanguageContext';

//Filtros
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import { DatePicker, MuiPickersUtilsProvider } from 'material-ui-pickers';
import MomentUtils from '@date-io/moment';
import enLocale from 'moment/locale/en-au';
import esLocale from 'moment/locale/es';
import Grid from '@material-ui/core/Grid';

//Auxiliars
import { convertToStringArray } from '../../../../utils/helpers'

//Notifications  
import Snackbar from '@material-ui/core/Snackbar';
import CustomNotification from '../../../../components/Notification/CustomNotification';

// JCMY 08/02/19

//services 
import { apiPOST, returnCurrentUserId } from '../../../../services/service_base';
//import apigClientFactory from '../../../../../static/apigClient.js'; 

import IconButton from '@material-ui/core/IconButton';
import CloudDownload from '@material-ui/icons/CloudDownload';

const locale = {
  en: enLocale,
  es: esLocale
}

//Keys to convert object to array 
const keys = ['tituloObra', 'autor', 'pais', "etapa", 'estatus', 'fechaRegistro'];
//const apigClient = apigClientFactory.newClient(); 

class AdvFilter extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      //Filters
      estatus: 0,
      tipoObra: 0,
      pais: 0,
      empresa: 0,
      fechaInicio: null,
      fechaFin: null,
      //Table
      columns: [],
      data: [],
      dataCsv: [],
      //Catalogues 
      countries: [],
      status: [],
      empresas: [],
      //Notifications
      open: false,
      errorMessage: "errMsg",
      //Loading 
      loading: false
    }
  }


  //Innputs
  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleDateChange = date => {
    this.setState({ fechaInicio: date });
  };

  handleDateChangeFin = date => {
    this.setState({ fechaFin: date });
  };

  //AHDA 19/02/2019
  handleClearFilters = () => {

    this.setState({
      estatus: '0',
      tipoObra: 0,
      pais: 0,
      empresa: '',
      fechaInicio: null,
      fechaFin: null,
      loading: true
    });

    const body = {
      fechaInicio: 0,
      fechaFin: 0,
      empresa: 0,
      estatusObra: '0',
      tipoObra: 0,
      pais: 0
    }
    this.handleFetch(body);
  }

  //Notifications 
  handleClose = () => {
    this.setState({ open: false });
  }

  // JCMY 08/02/19
  //Download csv
  handleDownload = (data) => {
    const body = {
      id_usuario: returnCurrentUserId(),
      user_action: 3,
      work_id: 0,
      portal: 'obras',
      screen: 'reporteObrasLiterarias'
    }
    apiPOST('/audit/add', body);

    //AHDA 31/05/2019
    // JCMY 06/06/2019
    const dataCsv = [["Título de la Obra", "Autor(es)/Nickname", "País", "Etapa", "Estatus", "Fecha de registro","Causa de no viabilidad"]]

    for (const x in data) {
      const object = []
      object.push(data[x]);
      dataCsv.push(object);
    }

    const download = document.createElement("a");
    document.body.appendChild(download); //AHDA 23/05/2019
    const blob = new Blob(["\ufeff", dataCsv.join('\n')], { type: 'application/vnd.ms-excel' });
    download.href = window.URL.createObjectURL(blob);
    download.download = "Obrasliterarias.csv";
    download.click();

  }

  //Search
  handleSearch = event => {
    event.preventDefault();
    const fi = this.state.fechaInicio === null ? 0 : new Date(this.state.fechaInicio);
    const ff = this.state.fechaFin === null ? 0 : new Date(this.state.fechaFin);

    let body = {
      fechaInicio: fi === 0 ? 0 : fi.getFullYear() + "-" + (fi.getMonth() + 1) + "-" + fi.getDate(),
      fechaFin: ff === 0 ? 0 : ff.getFullYear() + "-" + (ff.getMonth() + 1) + "-" + ff.getDate(),
      empresa: this.state.empresa === "" ? 0 : this.state.empresa === "TODOS" ? 0 : this.state.empresa,
      estatusObra: this.state.estatus,
      tipoObra: this.state.tipoObra,
      pais: this.state.pais
    }

    // JCMY 08/02/19
    const ds = new Date(fi);
    const df = new Date(ff);

    if (ds.getTime() > df.getTime()) {
      this.setState({ open: true, loading: false, errorMessage: "dateError" });
    } else {
      this.setState({ loading: true });
      this.handleFetch(body);
    }
  }

  componentDidMount() {

    this.setState({ loading: true });

    const { lang } = this.context;
    //AHDA 27/05/2019: Added nonViability
    this.setState(
      {
        columns: [lang.reports.empresa_proveedor,lang.reports.title, lang.reports.authors, lang.reports.tipo_obra, lang.reports.country, lang.reports.step ,  
          lang.reports.status, lang.reports.registerDate, lang.reports.nonViability]
      }
    )

    //AHDA 17/05/2019: added validation for refresh 
    apiPOST('/catalogos/getCatalogo', { idCatalogo: 3 }, true).then(
      response => {
        if (response.status === 200) {
          this.setState({ countries: response.data })
        }
      }
    )

    //AHDA 17/05/2019: added validation for refresh 
    apiPOST('/catalogos/getCatalogo', { idCatalogo: 7 }, true).then(
      response => {
        if (response.status === 200) {
          this.setState({ empresas: response.data })
        }
      }
    )

    //AHDA 17/05/2019: added validation for refresh 
    apiPOST('/catalogos/getCatalogo', { idCatalogo: 2 }, true).then(
      response => { 
        if (response.status === 200) {
          this.setState({ status: response.data })
        }
      }
    )

    //AHDA 27/05/2019: Changed estatusObra
    const body = {
      fechaInicio: 0,
      fechaFin: 0,
      empresa: 0,
      estatusObra: '0',
      tipoObra: 0,
      pais: 0
    }
    
    this.handleFetch(body);
  }

  handleFetch(body) {

    apiPOST('/reportes/obrasLiterarias', body).then(
      response => {
        if (response.status === 200) {
          const result = [];
          for (const x in response.data) {
            //AHDA 27/05/2019: Added validations
            var obj = [], item = response.data[x];
            obj.push(item.nombre_proveedor != null ? item.nombre_proveedor : response.data[x].companyProvider ? response.data[x].companyProvider : '-')
            // JCMY 03/06/2019
            obj.push(item.tituloObra != null ? item.tituloObra : "-");
            //AHDA 03/04/2019
            //Empty authors validation
            obj.push(response.data[x].autor ? response.data[x].authores ? `${response.data[x].authores}/${response.data[x].autor}` : response.data[x].autor : response.data[x].authores ? response.data[x].authores : '-');
            obj.push(item.tipo_obra != null ? item.tipo_obra : "-")
            obj.push(item.pais != null ? item.pais : "-");
            //EGS 23/04/2019
            // obj.push(item.anio);
            obj.push(item.etapa != null ? item.etapa : "-");
            obj.push(item.estatus != null ? item.estatus : "-");
            obj.push(item.fechaRegistro != null ? item.fechaRegistro : "-");
            obj.push(item.nonViability != null ? item.nonViability : "-"); //AHDA 27/05/2019
            
            
            result.push(obj);
          }
          this.setState({ data: result, loading: false, dataCsv: result });
        }
        else {
          this.setState({ open: true, loading: false, errorMessage: "errMsg" });
        }
      }
    ).catch(
      err => {
        this.setState({ open: true, loading: false, errorMessage: "errMsg" });
      }
    );
  }

  render() {
    const { classes } = this.props;
    const { columns, data, fechaInicio, fechaFin } = this.state;
    const options = {
      filterType: 'multiselect',
      responsive: 'scroll',
      download: false,
      print: false,
      rowsPerPage: 10,
      page: 0,
      selectableRows: false,
      textLabels: textLabelsEs,
      customToolbar: () => {
        return <LanguageConsumer>
          {
            ({ lang }) =>
              <Tooltip title={lang.reports.print} placement="bottom">
                <IconButton aria-label="download" onClick={() => this.handleDownload(this.state.dataCsv)}>
                  <CloudDownload />
                </IconButton>
              </Tooltip>
          }
        </LanguageConsumer>
      }
    };
    return (
      <LanguageConsumer>
        {
          ({ lang }) =>
            <div className="marginTopLogo">
              <PapperBlock title={lang.reports.reports} desc="">
                {/* Inicio Filtros */}
                {this.state.loading ? <LoaderFull /> : ''}
                <form className={classes.container} onSubmit={this.handleSearch}>
                  <Grid
                    container
                    spacing={24}
                    direction="row"
                    justify="flex-start"
                    alignItems="center">
                    <MuiPickersUtilsProvider utils={MomentUtils}>
                      <Grid item xs={6} sm={3} md={3}>
                          <DatePicker
                            keyboard={false}
                            helperText={lang.reports.startDate}
                            className={classes.formControl}
                            format="DD/MM/YYYY"
                            mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                            value={fechaInicio}
                            onChange={this.handleDateChange}
                            disableOpenOnEnter
                            animateYearScrolling={false}
                            disableFuture={true}
                            clearable={true}
                            cancelLabel={lang.common.cancel}
                            clearLabel={lang.common.clear}
                            placeholder="DD/MM/AAAA"
                          />
                      </Grid>
                      <Grid item xs={6} sm={3} md={3}>
                          <DatePicker
                            keyboard={false}
                            helperText={lang.reports.endDate}
                            className={classes.formControl}
                            format="DD/MM/YYYY"
                            mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                            value={fechaFin}
                            onChange={this.handleDateChangeFin}
                            disableOpenOnEnter
                            animateYearScrolling={false}
                            disableFuture={true}
                            minDate={fechaInicio}
                            clearable={true}
                            disabled={fechaInicio == null ? true : false}
                            cancelLabel={lang.common.cancel}
                            clearLabel={lang.common.clear}
                            placeholder="DD/MM/AAAA"
                          />
                      </Grid>
                    </MuiPickersUtilsProvider>
                    <Grid item xs={6} sm={3} md={3}>
                      <FormControl className={classes.formControl}>
                      {/* JCMY 26/03/19  */}
                      {/* No tomaba el valor seleccionado */}
                        <Select
                          value={this.state.empresa}
                          onChange={this.handleChange}
                          name="empresa"
                          displayEmpty
                          className={classes.selectEmpty}
                        >
                          <MenuItem value={0}>{lang.reports.all}</MenuItem>
                          {
                            this.state.empresas.map((empresa, idx) => (
                              <MenuItem value={empresa.value} key={`empresa${idx}`}>
                                {empresa.data}
                              </MenuItem>))
                          }
                        </Select>
                        <FormHelperText>{lang.reports.company}</FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs={6} sm={3} md={3}>
                      <FormControl className={classes.formControl}>
                        <Select
                          value={this.state.estatus}
                          onChange={this.handleChange}
                          name="estatus"
                          displayEmpty
                          className={classes.selectEmpty}
                          inputProps={{ name: 'estatus', id: 'filter-estatus' }}
                        >
                          {/*AHDA 27/05/2019*/}
                          <MenuItem value={"0"}>{lang.reports.all}</MenuItem>
                          {
                            this.state.status.map((stt, idx) => (
                              <MenuItem value={stt.value} key={`status${idx}`}>
                                {stt.data}
                              </MenuItem>))
                          }
                        </Select>
                        <FormHelperText>{lang.reports.playEstatus}</FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs={6} sm={3} md={3}>
                      <FormControl className={classes.formControl}>
                        <Select
                          value={this.state.tipoObra}
                          onChange={this.handleChange}
                          name="tipoObra"
                          displayEmpty
                          className={classes.selectEmpty}
                          inputProps={{ name: 'tipoObra', id: 'filter-tipoObra' }}
                        >
                          <MenuItem value={0}>{lang.reports.all}</MenuItem>
                          <MenuItem value={'Primigenia'}>{lang.reports.primal}</MenuItem>
                          <MenuItem value={'Adaptación'}>{lang.reports.adaptation}</MenuItem>
                        </Select>
                        <FormHelperText>{lang.reports.playType}</FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs={6} sm={3} md={3}>
                      <FormControl className={classes.formControl}>
                        <Select
                          value={this.state.pais}
                          onChange={this.handleChange}
                          name="pais"
                          className={classes.selectEmpty}
                          inputProps={{ name: 'pais', id: 'filter-pais' }}
                        >
                          <MenuItem value={0}>{lang.reports.all}</MenuItem>
                          {
                            this.state.countries.map((country, idx) => (
                              <MenuItem value={country.value} key={`country${idx}`}>
                                {country.data}
                              </MenuItem>))
                          }
                        </Select>
                        <FormHelperText>{lang.reports.country}</FormHelperText>
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={24}
                    direction="row"
                    justify="flex-start"
                    alignItems="center">
                    {/* CH 05/04/2019
                    Se centran botones en versión móvil */}
                    <Grid item xs={12} sm={12} md={12} className={classes.centerOnlySmall}>
                      <Button variant="contained" color="primary" className={classes.button} type="submit">
                        {lang.common.search}
                      </Button>
                      <Button variant="contained" color="primary" className={classes.button} onClick={this.handleClearFilters}>
                        Limpiar
                      </Button>
                    </Grid>
                  </Grid>
                </form>
                {/* Fin Filtros */}
                <div className={classes.reporteObras}>
                  <MUIDataTable
                    title={`${lang.reports.repLiteraryPlays} (${this.state.data.length} ${lang.reports.results})`}
                    data={data}
                    columns={columns}
                    options={options}
                  />
                </div>

                {/*for error notifications*/}
                <Snackbar
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  open={this.state.open}
                  autoHideDuration={6000}
                  onClose={this.handleClose}>
                  <CustomNotification
                    onClose={this.handleClose}
                    variant="error"
                    message={lang.common[this.state.errorMessage]} />
                </Snackbar>
              </PapperBlock>
            </div>
        }
      </LanguageConsumer>

    );
  }
}

AdvFilter.contextType = LanguageCxt;

export default withStyles(styles)(AdvFilter);
